var exports = {
  "p$": "DMChannelView.module__emptyState___ay1MZ0",
  "AI": "DMChannelView.module__emptyStateIcon___ay1MZ0",
  "vo": "DMChannelView.module__emptyStateTitle___ay1MZ0",
  "Li": "DMChannelView.module__emptyStateDescription___ay1MZ0",
  "fX": "DMChannelView.module__callParticipantsRow___ay1MZ0",
  "gN": "DMChannelView.module__compactCallParticipantsRow___ay1MZ0",
  "Gr": "DMChannelView.module__callParticipant___ay1MZ0",
  "Gj": "DMChannelView.module__callParticipantAvatar___ay1MZ0",
  "I9": "DMChannelView.module__callParticipantRinging___ay1MZ0",
  "rV": "DMChannelView.module__call-participant-ring-pulse___ay1MZ0",
  "Jn": "DMChannelView.module__callBanner___ay1MZ0",
  "nY": "DMChannelView.module__callBannerBody___ay1MZ0",
  "c7": "DMChannelView.module__callBannerResizable___ay1MZ0",
  "oo": "DMChannelView.module__callControlBarSection___ay1MZ0",
  "Pf": "DMChannelView.module__callControlBarInner___ay1MZ0",
  "tX": "DMChannelView.module__callControls___ay1MZ0",
  "pm": "DMChannelView.module__callBannerMobile___ay1MZ0",
  "h8": "DMChannelView.module__callBannerMobileLabel___ay1MZ0",
  "ZI": "DMChannelView.module__callControlsMobile___ay1MZ0",
  "IX": "DMChannelView.module__compactCallResizeHandle___ay1MZ0",
  "rF": "DMChannelView.module__compactCallResizePill___ay1MZ0",
};

module.exports = exports;
